





































































































































































































































































































































































































import { CrudService } from "../core/services/crudService";
import { Settings } from "../core/services/configService";
import Vue from "../node_modules/vue";
import Component from "../node_modules/vue-class-component";
import { Watch } from "vue-property-decorator";
import { LocalStorage } from "../core/localStorage";
import { DateHelper } from "../core/helpers/dateHelper";
import { Format } from "../core/helpers/formatHelper";
import Popup from "../components/popup/popup.vue";
import { ShopService } from "../core/services/shopService";
import { AttendanceMode, IsMobile } from "../core/constants";
import { Global } from "../core/helpers/global";
import CtaButton from "../components/ctaButton/ctaButton.vue";
import store from "../core/store";
import ServiceCard from "../components/bookings/ServiceCard.vue";
import MobileHeader from "../components/bookings/MobileHeader.vue";
import FilterPillsRow from "../components/filters/FilterPillsRow.vue";
import SearchBar from "../components/listings/SearchBar.vue";
import DateStripPicker from "../components/date/DateStripPicker.vue";

const AFTERNOON_START_HOUR = 13;
const SLOTS_VISIBLE = 8;

@Component({
  components: {
    Popup,
    CtaButton,
    ServiceCard,
    MobileHeader,
    FilterPillsRow,
    SearchBar,
    DateStripPicker,
  },
})
export default class BookingsPage extends Vue {
  errorMsg: string = "";
  data: any[] = [];
  dbData: any[] = [];
  date: string = "";
  bookingTypeSelected: any | null = null;

  attendanceChoice: string | null = null;

  get attendanceMode(): AttendanceMode {
    return this.bookingTypeSelected
      ? this.bookingTypeSelected.attendanceMode
      : AttendanceMode.InPerson;
  }

  get attendanceChoiceRequired(): boolean {
    return this.attendanceMode === AttendanceMode.Both;
  }

  get attendanceChoicePending(): boolean {
    return this.attendanceChoiceRequired && this.attendanceChoice === null;
  }

  get attendanceOptions() {
    return [
      { id: "inperson", label: this.$t("In person").toString() },
      { id: "online", label: this.$t("Online").toString() },
    ];
  }

  get isRemote(): boolean {
    if (this.attendanceMode === AttendanceMode.OnlineOnly) return true;
    return this.attendanceChoiceRequired && this.attendanceChoice === "online";
  }

  selectAttendance(id: string) {
    this.attendanceChoice = id;
    this.errorMsg = "";
  }

  resourceTypeId: number | null = null;
  showPopUpConfirm: boolean = false;
  bookingSelected: any = {};
  searchQuery: string = "";
  dbBookingTypes: any[] = [];
  resourceTypes: any[] = [];
  bookingTypes: any[] = [];
  anticipationMins: any = null;
  cancellationText: string = "";
  showOtherResources: boolean = false;
  otherResourceTypes: any[] | null = null;
  dataByResource: any | null;
  otherResourceOptionIndex = 0;
  blocks: any[] = [];
  optionalDate: Date | null = null;
  timetableLoading: boolean = false;
  showWaitlist: boolean = false;
  waitlistMsg: string = "";

  // Bottom sheet
  showBottomSheet: boolean = false;
  sheetSlot: any | null = null;
  depositByDuration: any = {};
  sheetResource: any | null = null;
  selectedDuration: number | null = null;

  // Expand state per resource index
  expandedMorning: Record<number, boolean> = {};
  expandedAfternoon: Record<number, boolean> = {};

  readonly slotsVisible: number = SLOTS_VISIBLE;

  // ── Slot helpers ─────────────────────────────────────────────

  getMorningSlots(resource: any): any[] {
    return (resource.timeTable || []).filter(
      (s: any) => this.slotHour(s) < AFTERNOON_START_HOUR,
    );
  }

  getAfternoonSlots(resource: any): any[] {
    return (resource.timeTable || []).filter(
      (s: any) => this.slotHour(s) >= AFTERNOON_START_HOUR,
    );
  }

  slotHour(slot: any): number {
    if (slot.start) return new Date(slot.start).getHours();
    if (slot.sstart) return parseInt(slot.sstart.split(":")[0], 10);
    return 0;
  }

  toggleExpand(period: "morning" | "afternoon", rIdx: number) {
    if (period === "morning") {
      this.$set(this.expandedMorning, rIdx, !this.expandedMorning[rIdx]);
    } else {
      this.$set(this.expandedAfternoon, rIdx, !this.expandedAfternoon[rIdx]);
    }
  }

  // ── Bottom sheet ──────────────────────────────────────────────

  openSheet(slot: any, resource: any) {
    this.sheetSlot = slot;
    this.sheetResource = resource;
    this.selectedDuration =
      slot.durations && slot.durations.length ? slot.durations[0] : null;
    this.depositByDuration = {};
    this.errorMsg = "";
    this.blocks = [];
    this.otherResourceOptionIndex = 0;
    this.showBottomSheet = true;
    this.$nextTick(() => this.getPrice(slot.id, 0, slot, resource.id));
  }

  closeSheet() {
    this.showBottomSheet = false;
    this.sheetSlot = null;
    this.sheetResource = null;
    this.selectedDuration = null;
    this.blocks = [];
    this.otherResourceOptionIndex = 0;
  }

  async confirmFromSheet(e: any) {
    if (!this.sheetSlot || !this.sheetResource || !this.selectedDuration)
      return;
    if (this.attendanceChoicePending) {
      this.errorMsg = this.$t("Choose in person or online").toString();
      return;
    }
    await this.selectDuration(
      e,
      this.selectedDuration,
      this.sheetResource,
      this.sheetSlot.start,
      this.sheetSlot.id,
      0,
      this.sheetSlot.noOnlineBlocks,
    );
  }

  // ── Existing logic (untouched) ────────────────────────────────

  async loadFilters() {
    let url = `${Settings.HostName}/api/publicbookings/filters`;
    if (!Format.IsNull(this.$route.params.bookingTypeId))
      url += `/${this.$route.params.bookingTypeId}`;
    let res = await new CrudService().httpGet(url);
    if (res == null || res.ok === false) {
      console.error("Crash getting filters");
      this.errorMsg = this.$t("Crash").toString();
      return;
    }
    this.dbBookingTypes = res.model.bookingTypes;
    this.bookingTypes = res.model.bookingTypes;
    this.resourceTypes = res.model.resourceTypes;
    this.anticipationMins = res.model.anticipationMins;
    this.cancellationText = res.model.cancellationText;
    this.setUpBookingTypeFilter();
    this.syncResourceTypeSelection();
  }

  syncResourceTypeSelection() {
    if (this.resourceTypeId === null || this.resourceTypeId === undefined)
      return;
    const found = this.resourceTypes.find((y) => y.id === this.resourceTypeId);
    if (found === undefined) this.resourceTypeId = null;
  }

  async mounted() {
    await this.loadFilters();
    if (!this.showBookingTypeCards && this.bookingTypeSelected === null) {
      this.$router.push("/bookings");
      return;
    }
    if (!this.showBookingTypeCards) await this.firstAvailableBooking();
  }

  setUpBookingTypeFilter() {
    if (this.showBookingTypeCards) {
      this.bookingTypeSelected = null;
      return;
    }
    if (this.bookingTypes.length === 1) {
      this.bookingTypeSelected = this.dbBookingTypes[0];
      return;
    }
    if (this.$route.params.bookingTypeId !== undefined) {
      const bookingTypeId = Number(this.$route.params.bookingTypeId);
      const selected = this.dbBookingTypes.find((y) => y.id == bookingTypeId);
      this.bookingTypeSelected = selected === undefined ? null : selected;
      return;
    }
    this.bookingTypeSelected = null;
  }

  get showBookingTypeCards() {
    const bookingTypeId = this.$route.params.bookingTypeId;
    return (
      bookingTypeId === undefined ||
      bookingTypeId === null ||
      bookingTypeId === ""
    );
  }

  get pageTitle() {
    if (this.showBookingTypeCards) return this.$t("Reserve").toString();
    if (this.bookingTypeSelected && this.bookingTypeSelected.name)
      return this.bookingTypeSelected.name;
    return this.$t("Reserve").toString();
  }

  get minSelectableDate() {
    return store.getters.localNow;
  }

  get isShowingFirstAvailable() {
    if (!this.optionalDate) return false;
    return this.date === DateHelper.toSystemString(this.optionalDate);
  }

  @Watch("$route.params.bookingTypeId")
  async onBookingTypeRouteChange() {
    if (this.showBookingTypeCards) {
      this.bookingTypeSelected = null;
      this.resourceTypeId = null;
      this.date = "";
      this.optionalDate = null;
      this.data = [];
      this.dbData = [];
      this.searchQuery = "";
      await this.loadFilters();
      return;
    }
    this.attendanceChoice = null;
    await this.loadFilters();
    if (this.bookingTypeSelected === null) {
      this.$router.push("/bookings");
      return;
    }
    this.resourceTypeId = null;
    this.data = [];
    this.dbData = [];
    this.optionalDate = null;
    await this.firstAvailableBooking();
    if (this.date !== null && this.date !== undefined && this.date !== "")
      await this.loadData();
  }

  async selectBookingType(bType: any) {
    if (
      bType.byPlace === true &&
      (Format.IsNull(bType.allowCreateBookByPlace) ||
        bType.allowCreateBookByPlace === false)
    ) {
      return this.$router.push("/bookings-byplace/" + bType.id);
    }
    if (this.bookingTypeSelected === bType.id) {
      this.bookingTypeSelected = null;
      return;
    }
    this.bookingTypeSelected = bType;
    if (this.bookingTypeSelected !== null) await this.loadData();
  }

  onResourceTypeSelected(resourceType: any) {
    if (resourceType === null || resourceType === undefined) {
      this.resourceTypeSelected(null);
      return;
    }
    this.resourceTypeSelected(resourceType.id);
  }

  async resourceTypeSelected(id: number | null) {
    if (this.resourceTypeId === id) {
      this.resourceTypeId = null;
      return;
    }
    this.resourceTypeId = id;
    if (this.bookingTypeSelected !== null) await this.loadData();
  }

  get bookingTypesFiltered() {
    if (!Array.isArray(this.bookingTypes)) return [];
    const q = (this.searchQuery || "").trim().toLowerCase();
    if (!q) return this.bookingTypes;
    return this.bookingTypes.filter((bookingType: any) => {
      const rawName =
        bookingType && (bookingType.name || bookingType.description)
          ? bookingType.name || bookingType.description
          : "";
      const rawDesc =
        bookingType && bookingType.extendedDescription
          ? bookingType.extendedDescription
          : "";
      return (
        rawName
          .toString()
          .toLowerCase()
          .includes(q) ||
        rawDesc
          .toString()
          .toLowerCase()
          .includes(q)
      );
    });
  }

  async firstAvailableBooking() {
    if (
      this.bookingTypeSelected === null ||
      this.bookingTypeSelected === undefined
    )
      return;
    Global.TriggerDomId = "loader";
    try {
      const res = await new CrudService().httpPost(
        `${Settings.HostName}/api/PublicTimeTableDates/getnextavailablebooking`,
        {
          date: store.getters.localNow,
          bookingTypeId: this.bookingTypeSelected.id,
        },
      );
      if (res.ok) {
        const firstDate = new Date(res.model.firstAvailableDate);
        firstDate.setHours(0, 0, 0, 0);
        this.optionalDate = firstDate;
        this.date = DateHelper.toSystemString(firstDate);
        await this.loadData();
      } else {
        this.errorMsg = res.errorMsg;
      }
    } catch (error) {
      console.error("Error al obtener la primera reserva disponible:", error);
    }
  }

  async loadData() {
    this.errorMsg = "";
    this.showWaitlist = false;
    this.waitlistMsg = "";
    this.expandedMorning = {};
    this.expandedAfternoon = {};
    if (
      this.date == null ||
      this.date === undefined ||
      this.dbBookingTypes.length === 0
    )
      return;
    if (
      this.bookingTypeSelected === null ||
      this.bookingTypeSelected === undefined
    )
      return;
    let cid = 0;
    let sid = LocalStorage.getWithTimeout("cc");
    if (sid !== undefined && sid !== null) cid = JSON.parse(sid).id;
    this.data = [];
    Global.TriggerDomId = "loader";
    const res = await new CrudService().httpPost(
      `${Settings.HostName}/api/publicbookings/list`,
      {
        date: this.date == "" ? store.getters.localNow : this.date,
        bookingTypeId: this.bookingTypeSelected.id,
        customerId: cid === 0 ? null : cid,
        resourceTypeId: this.resourceTypeId,
      },
    );
    if (res == null) {
      console.error("Crash getting bookings");
      return;
    }
    if (
      res.ok === false &&
      res.errorMsg !== undefined &&
      res.errorMsg !== null
    ) {
      this.errorMsg = res.errorMsg;
      return;
    }
    if (res.model.list.length === 0) {
      this.errorMsg = res.model.errorMsg;
      this.data.length = 0;
      // The center is open that day (a closed one fails with ok = false): every slot is
      // taken, so the customer can queue for it.
      this.showWaitlist = true;
      return;
    }
    this.data = res.model.list;
    this.otherResourceTypes = res.model.multipleResources;
    this.dbData = res.model.list;
  }

  async selectDuration(
    e: any,
    duration,
    resource,
    start,
    key,
    index,
    noOnlineBlocks: any = null,
  ) {
    e.preventDefault();
    this.blocks.push({
      duration,
      resourceId: resource.id,
      resourceName: resource.name,
      startDate: start,
      sstart: DateHelper.toCultureString(start),
      noOnline: false,
    });
    if (noOnlineBlocks !== null) {
      for (const b of noOnlineBlocks) {
        this.blocks.push({
          duration: b.duration,
          resourceId: b.resourceId,
          resourceName: b.resourceName,
          startDate: b.start,
          sstart: DateHelper.toCultureString(b.start),
          noOnline: true,
        });
      }
    }
    this.errorMsg = "";
    const othersLength =
      this.showOtherResources !== undefined && this.otherResourceTypes !== null
        ? this.otherResourceTypes.length
        : 0;
    if (othersLength != 0 && this.otherResourceOptionIndex < othersLength) {
      await this.loadRelatedResourceOptions(this.blocks[0]);
      this.showBottomSheet = false;
      this.showOtherResources = true;
      return;
    }
    this.showOtherResources = false;
    await this.addToCart(e);
  }

  async loadRelatedResourceOptions(block: any) {
    if (this.otherResourceTypes === null) return;
    let cid = 0;
    let sid = LocalStorage.getWithTimeout("cc");
    if (sid !== undefined && sid !== null) cid = JSON.parse(sid).id;
    const id = this.otherResourceTypes[this.otherResourceOptionIndex];
    const res = await new CrudService().httpPost(
      `${Settings.HostName}/api/publicbookings/date-availability`,
      {
        date: block.startDate,
        customerId: cid === 0 ? null : cid,
        bookingTypeResourceId: id,
      },
    );
    if (res == null) {
      console.error("Crash getting date-availability");
      return;
    }
    if (res.ok === false || res.model === null || res.model.length === 0) {
      this.errorMsg = this.$t(
        "Sorry nothing found. Try with other filters",
      ).toString();
      return;
    }
    this.otherResourceOptionIndex += 1;
    this.dataByResource = res.model;
  }

  async addToCart(e: any) {
    this.errorMsg = "";
    e.preventDefault();
    let cid = 0;
    let sid = LocalStorage.getWithTimeout("cc");
    if (sid !== undefined && sid !== null) cid = JSON.parse(sid).id;
    if (this.blocks.length === 0) return;
    if (cid === 0 || cid === null) {
      // Guest flow: keep the selection and resolve the prebook after login at checkout.
      let price = null;
      if (
        this.sheetSlot !== null &&
        this.sheetSlot.priceByDuration &&
        this.selectedDuration !== null
      ) {
        const cached = this.sheetSlot.priceByDuration[this.selectedDuration];
        if (cached !== undefined && cached !== null) price = cached.price;
      }
      LocalStorage.addWithTimout(
        "pendingBooking",
        {
          bookingTypeId: this.bookingTypeSelected.id,
          bookingTypeName: this.bookingTypeSelected.name,
          byPlace: this.bookingTypeSelected.byPlace,
          isRemote: this.isRemote,
          blocks: this.blocks,
          price,
        },
        new Date(new Date().getTime() + 30 * 60000),
      );
      this.showBottomSheet = false;
      this.$router.push("/checkout");
      return;
    }
    let booking: any = {
      customerId: cid,
      bookingTypeId: this.bookingTypeSelected.id,
      bookingTypeName: this.bookingTypeSelected.name,
      isRemote: this.isRemote,
      isValidated: false,
      sendCommunications: false,
      origin: 0,
      bookingByPlace: this.bookingTypeSelected.byPlace,
    };
    for (let i = 0; i < this.blocks.length; i++)
      this.blocks[i].customerId = booking.customerId;
    const res = await new CrudService().httpPost(
      `${Settings.HostName}/api/publicbookings/prebook`,
      {
        booking,
        customerIsParticipant: true,
        blocks: this.blocks,
        isMultiple: false,
      },
    );
    if (res === undefined) {
      this.showBottomSheet = false;
      this.errorMsg = "";
      return;
    }
    if (res == null) {
      console.error("Crash pre booking");
      this.errorMsg = this.$t("Crash").toString();
      return;
    }
    if (res.ok === false) {
      if (res.model !== undefined && res.model !== null) {
        this.errorMsg = Object.values(res.model).join(", ");
        return;
      }
      this.errorMsg = res.errorMsg;
      return;
    }
    if (res.model.serviceFree === true)
      return this.$router.push("/customer-bookings");
    let sale = res.model;
    sale.title = sale.description;
    sale.cancelUrl = `publicbookings/cancel/${sale.bookingId}/${cid}`;
    new ShopService().addSaleToCart(
      sale,
      document.getElementById("addToCartBtn"),
    );
    this.$router.push("/checkout");
  }

  async joinWaitlist(e: any) {
    e.preventDefault();
    if (this.$store.state.loggedIn === false) {
      this.$store.commit("openLogin");
      return;
    }
    const res = await new CrudService().httpPost(
      `${Settings.HostName}/api/publicwaitlist/add`,
      {
        bookingTypeId: this.bookingTypeSelected.id,
        date: this.date === "" ? store.getters.localNow : this.date,
      },
    );
    if (res == null || res.ok !== true) {
      this.waitlistMsg = this.$t("Crash").toString();
      return;
    }
    this.waitlistMsg =
      res.added === true
        ? this.$t("You are on the waiting list").toString()
        : this.$t("You were already on the waiting list").toString();
  }

  async filterByDate(date: any) {
    this.timetableLoading = true;
    await this.$nextTick();
    this.date = date.systemStrDate;
    await this.loadData();
    this.timetableLoading = false;
  }

  async getPrice(
    key: number,
    index: number,
    timetable: any,
    resourceId: number,
  ) {
    for (const duration of timetable.durations) {
      let spanPrice: any = document.getElementById(
        `id_price${key}${index}_${duration}`,
      );
      if (!spanPrice) continue;
      const cached =
        timetable.priceByDuration && timetable.priceByDuration[duration];
      if (cached !== null && cached !== undefined) {
        this.$set(this.depositByDuration, duration, cached.deposit);
        spanPrice.innerHTML = Format.formatCurrency(cached.price);
        continue;
      }
      let cid = 0;
      let sid = LocalStorage.getWithTimeout("cc");
      if (sid !== undefined && sid !== null) cid = JSON.parse(sid).id;
      const res = await new CrudService().httpPost(
        `${Settings.HostName}/api/publicbookings/loadprice`,
        {
          startDate: timetable.start,
          bookingTypeId: this.bookingTypeSelected.id,
          duration,
          customerId: cid === 0 ? null : cid,
          resourceId,
        },
      );
      const displayPrice = store.state.settings.PriceWithTaxes
        ? res.price.price
        : res.price.netPrice;
      const deposit =
        res.price.depositAmount !== undefined ? res.price.depositAmount : null;
      if (timetable.priceByDuration)
        timetable.priceByDuration[duration] = { price: displayPrice, deposit };
      this.$set(this.depositByDuration, duration, deposit);
      spanPrice.innerHTML = Format.formatCurrency(displayPrice);
    }
  }

  getSheetDeposit() {
    if (this.selectedDuration === null) return null;
    const deposit = this.depositByDuration[this.selectedDuration];
    return deposit !== undefined && deposit !== null && deposit > 0
      ? deposit
      : null;
  }

  getSheetDepositLabel() {
    return Format.formatCurrency(String(this.getSheetDeposit()));
  }

  getEnableUpTo() {
    if (Format.IsNull(this.anticipationMins)) return null;
    return DateHelper.addMinutes(store.getters.localNow, this.anticipationMins);
  }

  getResourceImage(image: string) {
    if (image !== undefined && image !== "" && image !== null)
      return store.state.settings.Uploads + "/" + image;
    return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
  }

  getBookingTypeTitle(bookingType: any) {
    if (!bookingType) return "";
    return bookingType.name || bookingType.description || "";
  }
  getBookingTypeDescription(bookingType: any) {
    if (!bookingType) return "";
    return bookingType.extendedDescription || bookingType.description || "";
  }
  getBookingTypePrice(bookingType: any) {
    if (!bookingType) return "";
    const value =
      bookingType.price || bookingType.grossPrice || bookingType.netPrice;
    if (Format.IsNull(value)) return "";
    return Format.formatCurrency(String(value));
  }
  getBookingTypeImage(bookingType: any) {
    if (!bookingType) return this.getBookingTypeAssetImage("");
    return this.getBookingTypeAssetImage(
      bookingType.image || bookingType.banner || "",
    );
  }
  getBookingTypeAssetImage(image: string) {
    if (!image)
      return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
    if (image.indexOf("http") === 0) return image;
    return store.state.settings.Uploads + "/" + image;
  }
  getBookingTypeUrl(bookingType: any) {
    if (!bookingType) return "/bookings";
    const byPlace =
      bookingType.byPlace === true || bookingType.bookingByPlace === true;
    if (
      byPlace &&
      (Format.IsNull(bookingType.allowCreateBookByPlace) ||
        bookingType.allowCreateBookByPlace === false)
    ) {
      return `/bookings-byplace/${bookingType.id}`;
    }
    return `/bookings/${bookingType.id}`;
  }
  goToBookingType(bookingType: any) {
    return this.$router.push(this.getBookingTypeUrl(bookingType));
  }
  goBack() {
    if (window.history.length > 1) {
      this.$router.back();
      return;
    }
    this.$router.push("/");
  }
  isMobile() {
    return IsMobile;
  }
}
